import React, { useState } from 'react';
import './login.scss';
import { supabase } from '../../lib/supabase';
// import { FcGoogle } from 'react-icons/fc';

interface LoginProps {
  onLogin: () => void;
}

type AuthMode = 'login' | 'register';

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mode, setMode] = useState<AuthMode>('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  // For backward compatibility with the existing authentication system
  // const handleLegacyLogin = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const correctPassword = 'aiutcc2025';
  //   if (password === correctPassword) {
  //     onLogin();
  //   } else {
  //     setError('Incorrect password');
  //     setTimeout(() => setError(null), 3000);
  //   }
  // };

  const handleEmailAuth = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      if (mode === 'login') {
        // Sign in with email and password
        const { data, error } = await supabase.auth.signInWithPassword({
          email,
          password,
        });

        if (error) throw error;
        if (data.user) {
          onLogin();
        }
      } else {
        // Sign up with email and password
        const { data, error } = await supabase.auth.signUp({
          email,
          password,
        });

        if (error) throw error;
        
        if (data.user?.identities?.length === 0) {
          setError('This email is already registered. Please log in instead.');
        } else {
          setMessage('Registration successful! Please check your email to confirm your account.');
        }
      }
    } catch (error: any) {
      setError(error.message || 'An error occurred during authentication');
    } finally {
      setLoading(false);
    }
  };

  // const handleGoogleSignIn = async () => {
  //   setLoading(true);
  //   setError(null);
    
  //   try {
  //     const { error } = await supabase.auth.signInWithOAuth({
  //       provider: 'google',
  //       options: {
  //         redirectTo: window.location.origin,
  //       },
  //     });
      
  //     if (error) throw error;
  //     // The redirect will happen automatically, so we don't need to call onLogin here
  //   } catch (error: any) {
  //     setError(error.message || 'An error occurred with Google sign-in');
  //     setLoading(false);
  //   }
  // };

  // Listen for auth state changes from OAuth redirects
  React.useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session) {
        onLogin();
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [onLogin]);

  const toggleMode = () => {
    setMode(mode === 'login' ? 'register' : 'login');
    setError(null);
    setMessage(null);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <img src="/jarvis_logo.png" alt="JARViS Logo" className="jarvis-logo" />
        </div>
        <h2>Jinnie Agentic Rapid Versatile Intelligent System</h2>
        
        <form onSubmit={handleEmailAuth}>
          <div className="input-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className={error ? 'error' : ''}
              required
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          
          <button type="submit" disabled={loading}>
            {loading ? 'Processing...' : mode === 'login' ? 'Sign In' : 'Sign Up'}
          </button>
          
          {/* <div className="auth-divider">
            <span>or</span>
          </div>
          
          <button 
            type="button" 
            className="google-button" 
            onClick={handleGoogleSignIn}
            disabled={loading}
          >
            <FcGoogle size={20} />
            <span>Continue with Google</span>
          </button> */}
          
          <div className="mode-toggle">
            {mode === 'login' ? (
              <p>
                Don't have an account?{' '}
                <button type="button" onClick={toggleMode} className="text-button">
                  Sign Up
                </button>
              </p>
            ) : (
              <p>
                Already have an account?{' '}
                <button type="button" onClick={toggleMode} className="text-button">
                  Sign In
                </button>
              </p>
            )}
          </div>
        </form>
        
        <div className="footer">
          <p>University of the Thai Chamber of Commerce</p>
          <p> 2025 Ai UTCC Incubation Center</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
